import * as React from "react";
import { Button, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { ReactComponent as DeleteIcon } from "assets/images/icons/deleteSvgIcon.svg";
import { DialogTitle, Grid, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";
import CommonButton from "./Button";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import { StaticTimePicker } from "@mui/x-date-pickers/StaticTimePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CommonToolTip from "components/common-component/Tooltip";
import CommonDropDown from "components/common-component/dropdownProjectChange";
import moment from "moment";
import { AI_getUserData } from "APIs/user";
import { useInstance } from "easy-redux-http-call";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import TextareaAutosize from '@mui/material/TextareaAutosize';

const useStyle = makeStyles((theme) => ({
  dialog: {
    position: "absolute",
    top: 280,
    width: "403px",
    Height:"278px !important",
    borderRadius:"32px",
    [theme.breakpoints.between("xs", "sm")]: {
      width: "80%",
    },
    textAlign: "center",
  },
  hrClose: {
    position: "absolute",
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
  hrText: {
    color: "#000",
    marginTop: 25,
    textAlign: "center",
  },
  hrMargin: {
    marginBottom: 20,
  },
  hrButton: {
    marginBottom: "15px",
    justifyContent: "center",
  },
  hrMainText: {
    "& div": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // marginBottom:"8px",
      paddingBottom: "4px",
      "& h6": {
        fontSize: "0.89rem",
        // width: "46%"
        width: "52%",
        marginRight: "5px",
      },
    },
    display: "content",
    gap: "10px",
    textAlign: "center",
  },
  hrIcon: {
    // backgroundColor:"red",
    position:"fixed",
    top:"260px",
    left:"47%",
    textAlign: "center",
    marginBottom:"10px",
  },
  hrSpan: {
    textAlign: "center",
    fontWeight: "bold",
    display: "flex",
    alignItems: "self-end",
    cursor: "pointer",
    width: "80px",
  },
  hrClockIcon: {
    color: "#d46b08",
    marginRight: "0.5rem",
    cursor: "pointer",
  },
  hrSubDialog: {
    display: "flex",
    flexDirection: "column",
    // alignItems: "center"
  },
  hrTimePickerOverlay: {
    "& .css-ypiqx9-MuiDialogContent-root": {
      overflowY: "hidden",
      overflowX: "hidden",
    },
    "&.css-1opbptt-MuiPickersLayout-root .MuiPickersLayout-actionBar": {
      display: "none",
    },
  },
  deleteIc:{
     borderRadius:"50%" ,
     borderWidth:"4px",
     "& >path":{
       fill:"#FFFFFF"
      }
  },
  statusContainer:{
    display: "flex",
    flexDirection:"column",
    width:"100%",
    justifyContent:"center"
  }
}));
/** common delete dialog component */
export default function ConfirmDeleteDialog(props) {
  const ProjectChangeTime = moment().format("HH:mm");
  const classes = useStyle();
  
  const {
    openStatus,
    confirmAction,
    confirmText = "Are you sure you want to delete?",
    logout,
    openWorkingProject = true,
    showClockIcon = false,
    setProjectTime: externalSetProjectTime,
    btnLable = "Delete",
    icon = <DeleteIcon 
    className={classes.deleteIc}
    />,
    loading = false,
    contentJSX,
    onTimeChange,
    showPunchInDropdown = false,
    onSelectTimeField,
    selectedFieldValue,
    headingText,
    projectStartTime,
    endTime,
    childStatus = false,
    onStatusChange,
    component,
    inputValue, 
    inputPlaceHolder,
    onInputChange 
  } = props;
  
  const [status, setStatus] = React.useState('');
  const [localValue, setLocalValue] = React.useState({
    value:'',
    length:0
  });

  const setProjectTime = showClockIcon
  ? externalSetProjectTime
  : ProjectChangeTime;
  const [openClock, setOpenClock] = React.useState(false);
  const handleOpenClock = () => {
    const isOpen = openClock == false;
    setOpenClock(isOpen ? true : false);
  };
  const getUserData = useInstance(AI_getUserData);
  const [selectedFieldTime, setSelectedFieldTime] = React.useState("");
  var punchInTime = getUserData?.data?.user?.employee?.punch_in_time;
  if (punchInTime) {
    var currentTime = moment();
    var punchInDateTime = moment(punchInTime);

    var timeDifference = Math.abs(currentTime - punchInDateTime);

    var threshold = 14 * 60 * 1000;
    if (timeDifference <= threshold) {
      var flagFordropdown = false;
    } else {
      var flagFordropdown = true;
    }
  }
  
  // DONT REMOVE BELOW CODE
  // const [selectedTime, setSelectedTime] = React.useState(dayjs());
  
  // const handleTimeChange = (newTime) => {
    //   setSelectedTime(newTime);
    //   // Do something with the new time value if needed
    //   console.log('Selected Time in App:', newTime?.format('HH:mm:ss'));
  // };

  // console.log('----->'+(selectedTime.format('HH:mm:ss')))
  const handleChange = (event, newValue) => {
    setStatus(newValue); 
    if (onStatusChange) {
      onStatusChange(newValue);
    }
  };
  
  const handleInputChange = (e) => {
    const newValue = e.target.value;
     const trimmedValue = newValue?.trim();
      const wordCount = trimmedValue ? trimmedValue?.split(/\s+/)?.length : 0;
    
      if (component === "showProjectEmp" && getUserData?.data?.user?.is_login) {
        setLocalValue({
          value: trimmedValue,
          length: wordCount,
        });
      }
    onInputChange(newValue);
  };

  return (
    <Dialog
      open={openStatus}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{ paper: classes.dialog }}
      >
      <DialogTitle className={classes.hrMargin}>
        {showClockIcon ? (
          <CommonToolTip title="When did you Start Working on this Project?">
            <span className={classes.hrSpan} onClick={handleOpenClock}>
              <AccessTimeFilledIcon className={classes.hrClockIcon} />
              {setProjectTime}
            </span>
          </CommonToolTip>
        ) : null}
        <IconButton
          aria-label="close"
          onClick={() => confirmAction(false)}
          className={classes.hrClose}
          color="error"
          >
          {/* <CloseIcon /> */}
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.hrSubDialog}>
        {openClock ? (
          //  <BasicTimeClock
          //  className={classes.hrTimePickerOverlay}
          // //  value={selectedTime}
          //  onChange={onTimeChange}
          //  />
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DemoContainer
              components={["StaticTimePicker"]}
              className={classes.root}
            >
              <StaticTimePicker
                orientation="landscape"
                className={classes.hrTimePickerOverlay}
                // value={selectedTime}
                onChange={onTimeChange}
              />
            </DemoContainer>
          </LocalizationProvider>
        ) : (
          <Grid className={classes.hrIcon}>{icon}</Grid>
        )}
        {/* <Grid className={classes.hrIcon}>{icon}</Grid> */}
        {contentJSX}

        <Grid className={classes.hrMainText}>
          <DialogContentText className={classes.hrText}>
            {showPunchInDropdown && flagFordropdown && (
              <>
                {(projectStartTime && logout === true && openWorkingProject) ? (
                  <div>
                    <Typography variant="h6">
                      Started working on project since :{" "}
                    </Typography>
                    <CommonDropDown
                      disabled={
                        window.location.pathname === "/personal-details"
                          ? true
                          : false
                      }
                      selectedValue={selectedFieldValue}
                      name="department_id"
                      onChangeAction={onSelectTimeField}
                      label=""
                      placeholder="Select Time"
                      enableTimeOptions={true}
                      projectStartTime={projectStartTime}
                      endTime={endTime}
                    />
                  </div>
                ) : null}
              </>
            )}
            {
              childStatus ? 
              (
                <div className={classes.statusContainer}>
                  <span
                  style={{fontSize:"15px",position:"relative",bottom:"10px"}}
                  >Select Child Status</span>
                  <Autocomplete
                  sx={{width:"200px"}}
                  value={status}
                  onChange={handleChange}
                  style={{display:"flex",justifyContent:"center"}}
                  options={["instock","archived","destroyed"]}
                  InputLabelProps={{
                    style: { paddingTop: "2px" }, 
                  }}
                  renderInput={(params) => <TextField {...params} label="Select Child Status" 
                  sx={{
                    "& .MuiInputBase-root": {
                      paddingTop: "4px", 
                      },
                    "& .MuiInputLabel-root": {
                      paddingTop: "1px !important", 
                      },

                  }}
                  
                  />}
                  />
                  </div>
                  
              )
              : null
            }
            <Typography  style={{marginBottom:"10px"}} variant="h2">{headingText}</Typography>
            <Typography style={{marginBottom:"10px"}} variant="h6">{confirmText}</Typography>
            {
              component === "showProjectEmp" && getUserData?.data?.user?.is_login && (
                <>
                  <TextareaAutosize
                    minRows={5}
                    maxRows={10}
                    placeholder={inputPlaceHolder || "Project?"}
                    onChange={handleInputChange}
                    style={{
                      width: "100%",
                      minHeight: "80px",
                      maxHeight: "100px",
                      overflow: "auto",
                      resize: "vertical",
                      borderRadius:"5px",
                      border: "2px solid rgba(244, 209, 188, 1)",
                      outline: "none",
                      padding: "8px",
                      fontSize: "14px",
                    }}
                  />
                      {
                        localValue.length < 10 && 
                        <p style={{color:"red"}}>
                         Please describe your work properly in a statement with minimum 10 words.</p>
                      }
                </>
              )
            }
          </DialogContentText>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.hrButton}>
        <Button 
        style={{backgroundColor:"white"}}
        variant="outlined" onClick={() => confirmAction(false)}>
          Cancel
        </Button>
        <CommonButton
          disabled={component === "showProjectEmp" && getUserData?.data?.user?.is_login && localValue?.length < 10 ? true : false  }
          loading={loading}
          variant="contained"
          onClick={() => confirmAction(true)}
        >
          yes, {btnLable}
        </CommonButton>
      </DialogActions>
    </Dialog>
  );
}
